import { Checkbox } from "primereact/checkbox";
import { classNames } from "primereact/utils";

export default function FormCheckbox(props) {
  const {
    className,
    setting: {
      Controller,
      control,
      setValue,
      trigger,
      isSubmitted,
      isEdit = true,
    },
    data: {
      name,
      label,
      value,
      type = "multi", // checked、multi
      disabled = false,
      saveFun = () => {},
    },
  } = props;

  const onChange = (e, field) => {
    const {
      checked,
      target: { name, value },
    } = e;

    if (type === "multi") {
      if (typeof field.value !== "object") field.value = [];
      if (e.checked) field.value.push(e.value);
      else field.value.splice(field.value.indexOf(value), 1);
    } else if (type === "checked") {
      field.value = e.checked;
    }

    // 因為是客製化的 function，設定欄位值後(setValue)，需要觸發(trigger) hookform，才會被驗證
    setValue(name, field.value);
    if (isSubmitted) {
      trigger();
    } else {
      trigger(name);
    }

    saveFun({ value, checked });
  };

  const checkedAction = ({ field }) => {
    return type === "multi"
      ? typeof field.value === "object"
        ? field.value?.indexOf(value) !== -1
        : false
      : field.value;
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <div
              className={classNames(
                className,
                "relative field-radiobutton min-w-220 mx-1 my-2"
              )}
            >
              <Checkbox
                inputId={`${field.name}_${value}`}
                className={classNames({ "p-invalid": fieldState.invalid })}
                {...field}
                value={value}
                checked={checkedAction({ field })}
                onChange={(e) => onChange(e, field)}
                disabled={!isEdit || disabled}
              />
              <label
                htmlFor={`${field.name}_${value}`}
                className="ml-1"
                // white-space-nowrap
              >
                {label}
              </label>
            </div>
          </>
        )}
      />
    </>
  );
}
